import { RepositoryUtils } from '../utils/RepositoryUtils';
import {
  EmailVerificationCheckType,
  EmailVerificationResponseType,
  IvyUsersMeType,
  LogoutResponseType
} from "../types/MemberTypes";

const ivyApiDomain = process.env.REACT_APP_IVY_APP_SERVER_API_DOMAIN;

export const loginByKakao = () => {
  return RepositoryUtils.axiosGet<any>(`${ivyApiDomain}/oauth2/authorization/kakao`, {
  });
};

export const loginByGoogle = () => {
  return RepositoryUtils.axiosGet<string>(`${ivyApiDomain}/oauth2/authorization/google`, {
  });
};

export const fetchUsersMe = (token: string) => {
  return RepositoryUtils.axiosGet<IvyUsersMeType>(`${ivyApiDomain}/api/v1/users/me`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};


export const emailVerificationRequest = (email: string) => {
  return RepositoryUtils.axiosPost<EmailVerificationCheckType>(`${ivyApiDomain}/api/v1/email/verification-request`, {
    email
  })
}

export const logoutRequest = (token: string) => {
  return RepositoryUtils.axiosPost<LogoutResponseType>(`${ivyApiDomain}/api/v1/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` }})
}


export const emailVerify = (verification: EmailVerificationCheckType) => {
  return RepositoryUtils.axiosGet<EmailVerificationResponseType>(`${ivyApiDomain}/api/v1/email/verify?uuid=${verification.uuid}&token=${verification.token}`)
}

export const testApi = () => {
  return RepositoryUtils.axiosGet<string>(`${ivyApiDomain}/api/v1/test/ping`, {
  });
};
